import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const EmployeesReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                employees:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.EMPLOYEES_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, employees: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_EMPLOYEES:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, employees: action.payload};

        case ActionTypes.EMPLOYEES_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.RESET_EMPLOYEES_ERROR:
            return {...state, errMess: null};

        case ActionTypes.ADD_EMPLOYEE:
            const nEmployee = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, employees: state.employees.concat(nEmployee)};
    
        case ActionTypes.UPDATE_EMPLOYEE:
            const uEmployee = action.payload;
            const updatedEmployees = state.employees.map(e => e.id === uEmployee.id ? uEmployee : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, employees: updatedEmployees};

        // case ActionTypes.DELETE_EMPLOYEE:
        //     const deId = action.payload;
        //     const filteredEmployees = state.employees.filter(e => e.id !== deId);
        //     return {...state, isLoading: false, errMess: null, employees: filteredEmployees};

        default:
            return state;
    }
};